<script setup>
import { ref, onMounted, watch, computed } from "vue";
import store from '@/store'
import utils from "@/utils/tool";
import {
    UserOutlined,
    LoginOutlined,
    SoundOutlined,
    ReadOutlined
} from '@ant-design/icons-vue';
import { useRouter } from "vue-router";
import Cookies from "js-cookie";
const router = useRouter();
const userInfo = ref([])
const handleLoginOut = () => {
    utils.showConfirmDialog('确定要退出吗？', () => {
        Cookies.remove('lginfo')
        Cookies.remove('token')
        Cookies.remove('lginfo', { path: '/', domain: '.zaimanhua.com' })
        Cookies.remove('token', { path: '/', domain: '.zaimanhua.com' })
        Cookies.remove('lginfo', { domain: '.zaimanhua.com' })
        Cookies.remove('token', { domain: '.zaimanhua.com' })
        utils.clear()
        router.push({ path: "/login" });
        window.location.reload()
    }, () => {
        console.log('用户点击取消');
    });

};
const hasUnreadMsg = ref(true);
const handleToPath = (name) => {
    router.push({ name: name });
};
watch(() => store.state.app.userInfo, (newValue) => {
    userInfo.value = JSON.parse(newValue);
});
onMounted(() => {
    if (Cookies.get('lginfo') && Cookies.get('lginfo') !== 'undefined') {
        userInfo.value = JSON.parse(Cookies.get('lginfo'))
    }
    initData()
})
const msgValue = ref();
const dyValue = ref();
async function initData() {
    await store.dispatch('user/GetMessage');
    msgValue.value = store.state.user.message.commentNotice + store.state.user.message.systemNotice + store.state.user.message.total
    hasUnreadMsg.value = msgValue.value ? msgValue.value > 0 : false;
    dyValue.value = store.state.user.message.subscribe
}
</script>
<template>
    <div class="header">
        <div class="new_top">
            <div class="top_fun">
                <a href="https://www.zaimanhua.com/" target="_blank">原创</a>
                <a href="https://manhua.zaimanhua.com/" target="_blank">日漫</a>
                <a href="https://news.zaimanhua.com/" target="_blank">宅新闻</a>
                <a href="https://wiki.zaimanhua.com/" target="_blank">WIKI</a>
                <a href="https://zt.zaimanhua.com/" target="_blank">专题</a>
                <a href="https://www.zaimanhua.com/app/index.html" target="_blank">手机APP</a>
            </div>
            <div class="top_login" v-if="Cookies.get('token')">
                <div class="textBtn">
                    <UserOutlined />
                    <span class="text">{{ userInfo.nickname }}</span>
                </div>
                <a-divider type="vertical" />
                <div class="textBtn" :class="{ 'msg-blink': hasUnreadMsg }" @click="handleToPath('message')">
                    <SoundOutlined class="msg-icon" />
                    <span class="text">消息{{ msgValue }}</span>
                    <span class="unread-dot" v-if="hasUnreadMsg"></span>
                </div>
                <a-divider type="vertical" />
                <div class="textBtn" @click="handleToPath('subscribe')">
                    <ReadOutlined />
                    <span class="text">订阅{{ dyValue }}</span>
                </div>
                <a-divider type="vertical" />
                <div class="textBtn" @click="handleLoginOut">
                    <LoginOutlined />
                    <span class="text">退出</span>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "style.scss";

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.msg-blink {
    .msg-icon {
        animation: blink 1.2s ease-in-out infinite;
    }
}

.unread-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ff4d4f;
    margin-left: 4px;
    vertical-align: middle;
}

.textBtn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
}
</style>